import React, { FunctionComponent } from "react";
import {
  Typography,
  DialogActions,
  DialogContentText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogProps,
  Theme,
  makeStyles,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { PrimaryButton } from "../buttons/primary-button";
import { PrimaryOutlinedButton } from "../buttons/primary-outlined-button";

const useStyles = makeStyles((theme: Theme) => ({
  dialog: {
    background: theme.palette.background.default,
  },
}));

interface IConfirmDialogProps extends DialogProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  heading: string;
  text?: string;
  confirmText: string;
}

export const ConfirmDialog: FunctionComponent<IConfirmDialogProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { open, onClose, onConfirm, heading, text, confirmText, maxWidth = "xs", fullWidth = true, ...rest } = props;
  return (
    <Dialog open={open} fullWidth={fullWidth} maxWidth={maxWidth} {...rest} classes={{ paper: classes.dialog }}>
      <DialogTitle>{heading}</DialogTitle>
      {text && (
        <DialogContent>
          <DialogContentText>
            <Typography>{text}</Typography>
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <PrimaryOutlinedButton onClick={onClose} color={"primary"}>
          {t("general.cancel")}
        </PrimaryOutlinedButton>
        <PrimaryButton onClick={onConfirm} color={"primary"}>
          {confirmText}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};
